import { render, staticRenderFns } from "./beDataTable.vue?vue&type=template&id=1b745d64&"
import script from "./beDataTable.vue?vue&type=script&lang=js&"
export * from "./beDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports